module.exports = __webpack_public_path__ + "static/media/1 27 hardt.1ef35d7d.mp3";